import { Card, CardContent, Typography, Box } from "@mui/material";

const AccessDenied: React.FC = () => {
	return (
		<Box display="flex" justifyContent="center" mt="10vh">
			<Card sx={{ maxWidth: 500, width: "100%" }}>
				<CardContent>
					<Typography variant="h5" color="error" gutterBottom>
						Access Denied
					</Typography>
					<Typography>
						You do not have permission to access the Event Manager.
					</Typography>
					<Typography sx={{ mt: 1.5 }}>
						This application is available to active staff only.
						Please contact your system administrator if you believe
						you should have access.
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
};

export default AccessDenied;
